// Componente ContactLabel simplificado
import React from "react";
import { getContrastColor, LABEL_COLORS } from "./label-utils";

export const ColorPicker = ({ selectedColor, onChange }) => {
  return (
    <div className="color-picker">
      {LABEL_COLORS.map((color) => (
        <div
          key={color}
          className={`color-option ${
            selectedColor === color ? "selected" : ""
          }`}
          style={{
            backgroundColor: color,
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            margin: "0 4px",
            cursor: "pointer",
            display: "inline-block",
            border:
              selectedColor === color
                ? "2px solid #000"
                : "2px solid transparent",
          }}
          onClick={() => onChange(color)}
        />
      ))}
    </div>
  );
};

export const ContactLabel = ({ label }) => {
  // Se não houver label ou faltar informações essenciais, não renderiza nada
  if (!label || !label.name || !label.color) {
    return null;
  }

  const { name, color } = label;
  const textColor = getContrastColor(color);

  return (
    <span
      className="contact-label"
      style={{
        backgroundColor: color,
        color: textColor,
        padding: "3px 8px",
        borderRadius: "4px",
        fontSize: "11px",
        fontWeight: "600",
        display: "inline-block",
        textTransform: "uppercase",
      }}
    >
      {name}
    </span>
  );
};
